import { useLandaAuthedApiLazyQuery } from 'hooks/api/graphql/landa_api';
import { useEffect } from 'react';
import { singletonHook } from 'react-singleton-hook';
import { useKycStore } from 'stores/KYCIdentities/kycIdentities';
import useAuth from '../../../context/Auth';
import { VERIFICATION_STATUS_QUERY } from 'graphql/kycIdentity/queries/verificationStatusQuery';

const init: { verificationStatus?: any; loading: boolean } = {
  verificationStatus: undefined,
  loading: false,
};

const useVerificationStatus = () => {
  const { kycIdentities, setVerificationStatus } = useKycStore();
  const { isLoggedIn } = useAuth();

  const [fetchVerificationStatusQuery, { loading }] =
    useLandaAuthedApiLazyQuery(VERIFICATION_STATUS_QUERY, {
      fetchPolicy: 'network-only',
    });
  const verificationStatus = kycIdentities?.attributes?.kyc_comments;
  useEffect(() => {
    if (!verificationStatus && isLoggedIn) {
      fetchVerificationStatusQuery({
        onCompleted: ({ kycIdentity }) => {
          setVerificationStatus(kycIdentity);
        },
      });
    }
  }, [verificationStatus]);

  return { verificationStatus, loading };
};

export default singletonHook(init, useVerificationStatus);
